<template>
    <div class="bg-yellow-50" id="transfer-receipt">
        <table class="w-full">
            <tbody>
                <tr>
                    <td
                        v-if="logo != null"
                        class="px-2 py-2 text-xs text-center font-bold"
                        colspan="2"
                    >
                        <img v-bind:src="`data:${logo.mime};base64, ${logo.base64}`"
                            class="mx-auto"
                            width="200"
                        />
                    </td>
                </tr>
                <tr v-if="extract.description">
                    <td
                        class="px-2 py-2 text-xs text-center"
                        colspan="2"
                    >
                        <span class="font-extrabold">{{ receipt.title.toUpperCase() }}<br/></span>
                        <span class="text-2xl font-extrabold">{{ receipt.subtitle }}</span>
                        <hr class="mt-2" />
                    </td>
                </tr>
                <td class="px-2 py-2 text-xs text-center font-bold" colspan="2">
                    DADOS DO PAGADOR
                </td>
                <tr v-if="receipt.content.bancoOrigem">
                    <td class="px-2 py-2 text-sm font-bold">Banco</td>
                    <td class="px-2 py-2 text-sm text-right">
                        {{ receipt.content.bancoOrigem.numero }} -
                        {{ receipt.content.bancoOrigem.descricao }}
                    </td>
                </tr>
                <tr v-if="receipt.content.agenciaContaOrigem">
                    <td class="px-2 py-2 text-sm font-bold">Conta</td>
                    <td class="px-2 py-2 text-sm text-right">
                        {{ receipt.content.agenciaContaOrigem.contaNumero }}-{{ receipt.content.agenciaContaOrigem.contaDigito }}
                    </td>
                </tr>
                <tr v-if="receipt.content.correntistaOrigem">
                    <td class="px-2 py-2 text-sm font-bold">Nome</td>
                    <td class="px-2 py-2 text-sm text-right">
                        {{ receipt.content.correntistaOrigem.nome }}
                    </td>
                </tr>
                <tr v-if="receipt.content.correntistaOrigem">
                    <td class="px-2 py-2 text-sm font-bold">Documento</td>
                    <td class="px-2 py-2 text-sm text-right">
                        {{
                            receipt.content.correntistaOrigem.documentoFederal
                                | federalDocument
                        }}
                    </td>
                </tr>
                <tr v-if="receipt.content.vlrTitulo">
                    <td class="px-2 py-2 text-sm font-bold">Valor do título</td>
                    <td class="px-2 py-2 text-sm text-right">
                        {{ receipt.content.vlrTitulo | currency }}
                    </td>
                </tr>
                <tr v-if="receipt.content.vlrMoraMulta">
                    <td class="px-2 py-2 text-sm font-bold">Multa</td>
                    <td class="px-2 py-2 text-sm text-right">
                        {{ receipt.content.vlrMoraMulta | currency }}
                    </td>
                </tr>
                <tr v-if="receipt.content.vlrOutrosAcres">
                    <td class="px-2 py-2 text-sm font-bold">
                        Outros acréscimos
                    </td>
                    <td class="px-2 py-2 text-sm text-right">
                        {{ receipt.content.vlrOutrosAcres | currency }}
                    </td>
                </tr>
                <tr v-if="receipt.content.vlrDesconto">
                    <td class="px-2 py-2 text-sm font-bold">Desconto</td>
                    <td class="px-2 py-2 text-sm text-right">
                        {{ receipt.content.vlrDesconto | currency }}
                    </td>
                </tr>
                <tr v-if="receipt.content.tituloDtVencimento">
                    <td class="px-2 py-2 text-sm font-bold">
                        Data do vencimento
                    </td>
                    <td class="px-2 py-2 text-sm text-right">
                        {{ receipt.content.tituloDtVencimento | smallDate }}
                    </td>
                </tr>
                <tr v-if="receipt.content.codigoBarras">
                    <td class="px-2 py-2 text-sm text-center" colspan="2">
                        <span class="font-bold">Código de barras</span><br />{{
                            receipt.content.codigoBarras
                        }}
                    </td>
                </tr>
                <tr>
                    <td class="px-2 py-2 text-xs text-center" colspan="2">
                        <hr />
                    </td>
                </tr>
                <tr>
                    <td class="px-2 py-2 text-xs text-center font-bold" colspan="2">
                        BENEFICIARIO
                    </td>
                </tr>
                <tr v-if="receipt.content.tituloNome">
                    <td class="px-2 py-2 text-sm text-center" colspan="2">
                        <span class="font-bold">{{ receipt.content.tituloNome }}</span>
                        <br />
                        <span>{{ receipt.content.tituloDocumentoFederal | federalDocument }}</span>
                        <br />
                        <span class="text-3xl font-extrabold">
                            R$ {{ receipt.content.vlrTransacao | currency }}
                        </span >
                    </td>
                </tr>
                <tr v-if="receipt.content.correntistaDestino">
                    <td class="px-2 py-2 text-sm text-center" colspan="2">
                        <span class="font-bold">{{ receipt.content.correntistaDestino.nome }}</span>
                        <br />
                        <span>{{ receipt.content.correntistaDestino.documentoFederal | federalDocument }}</span>
                        <br />
                        <span class="text-3xl font-extrabold">R$ {{ receipt.content.vlrTransacao | currency }}</span>
                    </td>
                </tr>
                <tr v-if="receipt.content.bancoDestino">
                    <td class="px-2 py-2 text-sm font-bold">Banco</td>
                    <td class="px-2 py-2 text-sm text-right" v-if="extract.description && extract.description.includes('DEVOLUCAO PIX')">
                        {{ receipt.content.bancoDestino.descricao }}
                    </td>
                    <td class="px-2 py-2 text-sm text-right" v-else>
                        {{ receipt.content.bancoDestino.numero }} -
                        {{ receipt.content.bancoDestino.descricao }}
                    </td>
                </tr>
                <tr v-if="receipt.content.agenciaContaDestino">
                    <td class="px-2 py-2 text-sm font-bold">Agência</td>
                    <td class="px-2 py-2 text-sm text-right" v-if="receipt.content.agenciaContaDestino.agenciaDigito">
                        {{
                            formatNumberAgencia(receipt.content.agenciaContaDestino.agenciaNumero)
                        }}-{{
                            receipt.content.agenciaContaDestino.agenciaDigito
                        }}
                    </td>
                    <td class="px-2 py-2 text-sm text-right" v-else>
                        {{
                            formatNumberAgencia(receipt.content.agenciaContaDestino.agenciaNumero)
                        }}
                    </td>
                </tr>
                <tr v-if="receipt.content.agenciaContaDestino">
                    <td class="px-2 py-2 text-sm font-bold">
                        Conta
                        {{ accountTypes[receipt.content.destinoTipoConta] }}
                    </td>
                    <td class="px-2 py-2 text-sm text-right" v-if="receipt.content.agenciaContaDestino.contaDigito" >
                        {{ receipt.content.agenciaContaDestino.contaNumero }}-{{
                            receipt.content.agenciaContaDestino.contaDigito
                        }}
                    </td>
                    <td class="px-2 py-2 text-sm text-right" v-else>
                        {{ formatNumber(receipt.content.agenciaContaDestino.contaNumero) }}
                    </td>
                </tr>
                <tr v-if="receipt.content.descCliente">
                    <td class="px-2 py-2 text-sm font-bold">Descrição</td>
                    <td class="px-2 py-2 text-sm text-right">
                        {{ receipt.content.descCliente }}
                    </td>
                </tr>
                <tr v-if="receipt.content.tituloNumControle">
                    <td class="px-2 py-2 text-sm font-bold">Nosso número</td>
                    <td class="px-2 py-2 text-sm text-right">
                        {{ receipt.content.tituloNumControle }}
                    </td>
                </tr>
                <tr v-if="extract">
                    <td class="px-2 py-2 text-sm font-bold">Desc. Operação</td>
                    <td class="px-2 py-2 text-sm text-right">
                        {{ receipt.content.DescOperacao || extract.operation_description }}
                    </td>
                </tr>
                <tr v-if="extract && extract.operation_code">
                    <td class="px-2 py-2 text-sm font-bold">
                        Identificador
                    </td>
                    <td class="px-2 py-2 text-sm text-right">
                        {{ extract.operation_code }}
                    </td>
                </tr>
                <tr v-if="receipt.content.dtTransacao">
                    <td class="px-2 py-2 text-sm font-bold">
                        Data da transação
                    </td>
                    <td class="px-2 py-2 text-sm text-right">
                        {{ receipt.content.dtTransacao | smallDateTime }}
                    </td>
                </tr>
                <tr>
                    <td class="px-2 py-2 text-xs text-center" colspan="2">
                        <hr />
                    </td>
                </tr>
                <tr v-if="receipt.content.numeroOperacao">
                    <td class="px-2 py-2 text-center" colspan="2">
                        <span class="text-bold" v-if="extract.description && extract.description.includes('DEVOLUCAO PIX')">ID original da transação</span>
                        <span class="text-bold" v-else>ID da transação</span><br />
                        <span class="text-xs">
                            {{ receipt.content.numeroOperacao }}
                        </span>
                    </td>
                </tr>
                <tr>
                    <td class="px-2 py-2 text-center" colspan="2">
                        <span class="text-bold" v-if="extract.description && extract.description.includes('DEVOLUCAO PIX')">Autenticação original da transação</span>
                        <span class="text-bold" v-else>Autenticação</span><br />
                        <span class="text-xs">
                            {{ receipt.content.transfCodigoAutenticacao || receipt.content.codigoAutenticacao }}
                        </span>
                    </td>
                </tr>
                <tr v-if="extract.description && extract.description.includes('DEVOLUCAO PIX')">
                    <td class="px-2 py-2 text-xs text-center" colspan="2">
                        <hr />
                    </td>
                </tr>
                <tr v-if="extract.description && extract.description.includes('DEVOLUCAO PIX') && extract.end_to_end_code">
                    <td class="px-2 py-2 text-center" colspan="2">
                        <span class="text-bold">ID do estorno</span><br />
                        <span class="text-xs">
                            {{ extract.end_to_end_code }}
                        </span>
                    </td>
                </tr>
                <tr v-if="extract.description && extract.description.includes('DEVOLUCAO PIX')">
                    <td class="px-2 py-2 text-center" colspan="2">
                        <span class="text-bold">Autenticação</span><br />
                        <span class="text-xs">
                            {{ extract.code }}
                        </span>
                    </td>
                </tr>
                <tr v-if="!$page.props.white_label.data.is_main_business_unit">
                    <td class="px-2 py-2 text-center" colspan="2">
                        <span class="text-xs">
                            Powered by 2GO Bank
                        </span>
                    </td>
                </tr>
            </tbody>
        </table>
    </div>
</template>

<script>
export default {
    name: "Receipt",
    props: ['receipt', 'extract', 'errors', 'logo', 'refund'],
    methods: {
        formatNumber(number) {
            return number.slice(0, -1) + "-" + number.slice(-1);
        },
        formatNumberAgencia(number) {
            if (number.length < 4) {
                return number.padStart(4, "0");
            }
            return number;
        },
    },
    data() {
        return {
            accountTypes: {
                1: "Corrente",
                2: "Poupança",
                3: "Pagamento"
            }
        };
    },
    computed: {
        titleReceipt(){
            if(this.extract.description.includes('DEVOLUCAO PIX')){
                return 'ESTORNO PIX'
            } else if(this.extract.description.includes('ENTRE CONTAS DEBITO')){
                return 'ENVIO ENTRE CONTAS'
            } else if(this.extract.description.includes('ENVIO PIX')){
                return this.extract.description
            } else if(this.extract.description.includes('TED')){
                return 'ENVIO TED'
            }
        }
    }
};
</script>
